export interface PostDto {
  id: number;
  userId: number;
  content: string;
  createdAt: string; // ISO

  locationId: number | null;
  locationName: string | null;

  categoryId: number | null;
  categoryName: string | null;

  likeCount: number;

  images: string[]; // URLs like "/uploads/posts/{id}/{file}"
  imageCount?: number;
  tags: string[]; // names
  comments: PostCommentDto[];

  userName?: string;

  isLikedByUser?: boolean;
}
export interface PostCommentDto {
  id: number;
  userId: number;
  comment: string;
  createdAt: string;
  userName?: string;
  isLikedByUser?: boolean;
  likeCount?: number;
}

export interface GetPostsRequest {
  page?: number; // default 1
  pageSize?: number; // default 20
  categoryId?: number;
  locationId?: number;
  tag?: string;
}
export interface CreatePostRequest {
  content: string;
  locationId?: number | null;
  categoryId?: number | null;
  tags?: string | null; // "tag1, tag2"
  files?: File[] | null; // up to 5
}

export interface CreatePostCommentRequest {
  postId: number;
  comment: string;
}

export interface CreatePostResponse {
  id: number;
}

export interface PostImagesResponse {
  postId: number;
  images: string[];
}

export interface FeedCategoryDto {
  id: number;
  name: string;
  postCount: number;
}

export interface FeedTrendingTagDto {
  tag: string;
  postCount: number;
}

export interface FeedPopularUserDto {
  id: number;
  name: string;
  avatar: string;
  posts: number;
}

export interface FeedDailyStatsDto {
  postsToday: number;
  visitorsToday: number;
}

export type CreatePostCommentResponse = number | { id: number };

export const extractCommentId = (res: CreatePostCommentResponse): number => (typeof res === 'number' ? res : res.id);

export const MAX_IMAGES = 5;

export type PrivacyType = 'public' | 'friends' | 'private';

export interface AddPostDraftDto {
  content: string;
  files: File[];
  previews: string[];
  privacy: PrivacyType;

  // optional for later (your backend supports them)
  locationId?: number | null;
  locationName?: string | null;
  categoryId?: number | null;
  tags?: string | null; // comma/space separated
}

export interface PostLocationOptionDto {
  id: string;
  label: string;
  meta?: string;
  locationId?: number | null;
  latitude?: number | null;
  longitude?: number | null;
  type?: string;
  mapTargetId?: string | null;
}

export interface FeedPagePropsDto {
  posts: PostDto[];
  onAddComment: (postId: number, commentText: string) => void;
  onLike: (targetId: number, targetType: 'post' | 'comment') => void;
  onReport: (targetId: number, targetType: 'post' | 'comment') => void;
}

export interface AddPostPropsDto {
  onAddPost: (content: string, images?: File[], extras?: Partial<AddPostDraftDto>) => void;
  suggestedTags?: string[];
  locationOptions?: PostLocationOptionDto[];
  onLocationSelect?: (location: PostLocationOptionDto) => void;
}

export interface PostCardPropsDto {
  post: PostDto;
  onAddComment: (postId: number, commentText: string) => void;
  onLike?: (postId: number) => void;
}

export interface CommentInputStateDto {
  [postId: number]: string;
}

export interface ExpandedCommentsStateDto {
  [postId: number]: boolean;
}

export const API_ORIGIN = process.env.REACT_APP_API_URL ?? 'https://localhost:4000';

export const toAbsoluteUrl = (url: string) => {
  if (!url) return url;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('blob:') || url.startsWith('data:')) return url;
  const base = API_ORIGIN.endsWith('/') ? API_ORIGIN.slice(0, -1) : API_ORIGIN;
  const path = url.startsWith('/') ? url : `/${url}`;
  return `${base}${path}`;
};
